import type { IxcOrdersV1BatchOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const BATCH_ORDER_BASE_PATH = getResolvedPath('/order/equity/batch');

export const getBatchOrderPath: EntityPathBuilder<IxcOrdersV1BatchOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (context?.keys?.accountId) {
        // return getResolvedPath('/registration/account/$accountId/order/batch', context.keys);
      }

      return BATCH_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.batchOrderId) {
        return undefined;
      }

      // if (context?.keys?.accountId) {
      //   return getResolvedPath('/registration/account/$accountId/order/batch/$batchOrderId', context.keys);
      // }

      return getResolvedPath(`${BATCH_ORDER_BASE_PATH}/$batchOrderId`, context.keys);
    }
  }
};

export function getBatchOrderDetailPath(batchOrderId: string | undefined, accountId?: string) {
  if (!batchOrderId) {
    return undefined;
  }

  return getBatchOrderPath({ kind: 'detail', keys: { batchOrderId, accountId } });
}
